class Document {
  constructor(...pages) {
    this.pages = pages
  }

  addPages(...pages) {
    pages.map(page => {
      this.pages.push(page)
    })
  }

  getCount() {
    return this.pages.length
  }
}

export {Document}



// WEBPACK FOOTER //
// ./src/model/Document.js